<template>
    <div v-if="isLoaded && isHaveCategory">
        <CategorySlider
            :categorie="categories"
            @changeCategory="changeCategory($event)"
        ></CategorySlider>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";

import CategorySlider from "./Category/CategorySlider.vue";
export default {
    name: "Category",
    components: {
        CategorySlider
    },
    props: {
        config: String,
    },
    data: function() {
        return {
            categories : [],
            isLoaded : false ,
            isHaveCategory : false,
        }
    },
    methods: {
        initialCategory: function () {
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(this.config)
                .setLocale(this.locale);

            this.categoryConfig = categoryConfig.create();

            this.getCategory();
        },
        getCategory: function () {
            var categoryParam = this.categoryConfig
                .getParams();

            var token = Account.getToken();
            BzbsCategory.apiGetCategory(token, categoryParam).subscribe((categories) => {
                for (var category of categories) {
                    this.categories.push(category);
                }

                this.isLoaded = true;
                this.isHaveCategory = this.categories.length > 0
                    ? true
                    : false;

                this.changeCategory(this.categories[0]);
            }, (err) => {
                console.log(err);
                this.isLoaded = true;
                this.isHaveItem = false;
                this.$emit('changeCategory', err);
            });
        },
        changeCategory: function (category) {
            this.$emit('changeCategory', category);
        },
    }
}
</script>

<style>

</style>
